import type { IRecord } from '@platform/core/types';
import type { ILawGroup } from './ILawGroup';

/** Значення поля запису як рядок (назва й статус — з конверта; порожнє — ''). */
export function lawValue(r: IRecord, field: string): string {
  const v = field === 'title' ? r.title : field === 'status' ? r.status : r.values[field];
  return v == null ? '' : typeof v === 'object' && 'id' in v ? String(v.id) : String(v);
}

/**
 * Групи записів за значенням поля в порядку `order` (варіанти поля з визначення), лише непорожні (прототип v4: ROLE / RELS / SUB
 * .filter(x => items.some(...))). Чиста функція.
 */
export function groupsOf(items: readonly IRecord[], field: string, order: readonly string[]): ILawGroup[] {
  return order.map((value) => ({ value, items: items.filter((r) => lawValue(r, field) === value) })).filter((g) => g.items.length > 0);
}

/** Групи за значенням поля в порядку першої появи (розділи закону; порожнє значення — «—»). Чиста функція. */
export function groupsInOrder(items: readonly IRecord[], field: string): ILawGroup[] {
  const groups: ILawGroup[] = [];
  for (const r of items) {
    const value = lawValue(r, field) || '—';
    const group = groups.find((g) => g.value === value);
    if (group) group.items.push(r);
    else groups.push({ value, items: [r] });
  }
  return groups;
}
